import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import DatePicker from "react-datepicker";
import Modal from 'react-responsive-modal';
import {NavLink, Link} from 'react-router-dom';


class Postnew extends Component {
    constructor(props) {
        super(props);

        this.updateTitle = this.updateTitle.bind(this);
        this.updateContent = this.updateContent.bind(this);
        this.updateDepartment = this.updateDepartment.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);

        this.postAnnouncement = this.postAnnouncement.bind(this);



        this.state={
           user_details:this.props.user_details,
           access_token:this.props.access_token,
           loading:false,
           api_error:false,
           loaded_successfully:false,
           api_error_message:"",
           title:"",
           content:"",
           selectedDepartment:0,
           api_loading:false,
            api_loading_message:"",
           endDate:new Date(),
           startDate: new Date(),
            minDate: new Date(),

        }
     }

     updateStartDate(date)
      {
        this.setState({startDate:date}); 
      }

      updateEndDate(date)
      {
        this.setState({endDate:date}); 
      }



     updateTitle(event)
      {
          this.setState({title:event.target.value, server_changes_made:false});
      }

      updateContent(event)
      {
          this.setState({content:event.target.value, server_changes_made:false});
      }

      updateDepartment(event)
      {
          this.setState({selectedDepartment:event.target.value});
      }

      postAnnouncement()
      {
        this.setState({api_loading:true, api_loading_message:"Posting Announcement, please wait....."});
        const _this = this;


        let title = _this.state.title;
        let content = _this.state.content;
        let start_date = _this.state.startDate ;
        let end_date = _this.state.endDate;
        let posted_by = _this.props.admin_details.core_details._id ;
        let general = _this.state.selectedDepartment == 0 ? 1 : 0;
        let department = _this.state.selectedDepartment == 0 ? null : _this.state.selectedDepartment;
        
        const url = this.props.base_url +"/admin/post_announcement";



        superagent
        .post(url)
        .send({"title":title, "content":content, "general":general, "department":department, "posted_by":posted_by, "start_date":start_date, "end_date": end_date})
        .set('Accept', 'application/json')
        .set('Content-Type', 'application/json')
        .set('Authorization', 'Bearer '+ _this.state.access_token)
        .then(function(res){
            //res.body, res.headers, res.status
            let error = res.body.error;
            console.log("Response", res.body);


            if(!error)
            {

                console.log("Process", "successful posted");
                _this.setState({api_loading:false, title:"", selectedDepartment:0, content:"", mode:0, loaded_successfully:true, api_error_message:"Posted successfully", department:"0", server_changes_made:true});
        

            }
            else
            {
                _this.setState({api_loading:false, loaded_successfully:false, api_error_message:"Error creating record"});
            }

        })
        .catch(function(err){

            console.log("error response", err);
            _this.setState({api_loading:false, loaded_successfully:false, api_error_message:err});
        });

      }

      renderLoadingProgress()
      {
        const _this = this;
          if(this.state.api_loading)
          {
              return(
                <div className="loading-progress">
                <div >
                    {_this.state.api_loading_message}
                    <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
                </div>
            </div>
    
              );
          }
          else{
              return null;
          }
      }

      renderErrorMessage()
      {
        const _this = this;
    
          if(_this.state.api_error && !_this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p>{_this.state.api_error_message}</p>
                    </div>
                </div>
              );
          }
          else if(_this.server_changes_made && !_this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p>{_this.state.api_error_message}</p>
                    </div>
                </div>
              );
          }
          else
          {
            return null;
          }
    
      }




  render() {
    const _this=this;

  
    let department_options;
  

    if(_this.props.admin_details.departments)
        {

        department_options = _this.props.admin_details.departments.map(department =>
                {
                console.log(department);
                return (
                    <option key={department.ID} value={department.ID}>{department.names}</option>
                        );
                });
        }
        else
        {
            department_options=null;
        }

   

    return (
      <div className="main-panel">

        <Header title ="New Announcements" />

        <div className="content">
            <div className="container-fluid">
                <div className="row">

                    <div className="col-lg-12 col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title text-center">Post New Announcement</h4>
                            </div>
                            <div className="card-body">

                                    {this.renderLoadingProgress()}
                                    {this.renderErrorMessage()}

                                <div className="form-group bmd-form-group row">
                                    <div style={{display:"inline", float:"left"}}>
                                        <span className="control-label" style={{display:"inline", float:"left" }}>Select Department : </span>
                                    </div>
                                    <div style={{display:"inline", minWidth:"60%", marginLeft:"10px"}}>
                                        <select value={_this.state.selectedDepartment} style={{height:'auto', fontSize:'14px', paddingBottom:'5px',  paddingTop:'5px'}} className="select-box" onChange = {this.updateDepartment.bind(_this)}   >
                                                <option style={{paddingBottom:'5px',  paddingTop:'5px'}} value="0"> General </option>
                                                {department_options}
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group bmd-form-group">
                                    <label for="title">Announcement Title:</label>
                                    <textarea type="text" onChange={_this.updateTitle.bind(_this)} placeholder ={_this.state.title} value ={_this.state.title}  class="form-control" rows="1" id="title"></textarea>
                                </div>


                                <div class="form-group bmd-form-group">
                                    <label for="comment">Announcement Content:</label>
                                    <textarea type="text" onChange={_this.updateContent.bind(_this)} placeholder ={_this.state.content}  value ={_this.state.content}  class="form-control" rows="5" id="comment"></textarea>
                                </div>

                                

                                <div className="form-group">
                                    <label for="dt-cont">Start Date </label>
                                    <span id ="dt-cont" className="div-form-control">
                                        <DatePicker
                                                selected={_this.state.startDate}
                                                minDate = {_this.state.minDate}
                                                filterDate = {this.isWeekday}
                                                dateFormat="dd/MM/yyyy"
                                                yearDropdownItemNumber = {2}
                                                showYearDropdown = {true}
                                                id="dt-start"
                                                className = "bordered-form-control"
                                                scrollableYearDropdown ={true}
                                                onChange={this.updateStartDate}/> 
                                    </span>
                                </div>

                                <div className="form-group">
                                    <label for="dt-cont">End Date </label>
                                    <span id ="dt-cont" className="div-form-control">
                                        <DatePicker
                                                selected={_this.state.endDate}
                                                minDate = {_this.state.minDate}
                                                filterDate = {this.isWeekday}
                                                dateFormat="dd/MM/yyyy"
                                                yearDropdownItemNumber = {2}
                                                showYearDropdown = {true}
                                                id="dt-start"
                                                className = "bordered-form-control"
                                                scrollableYearDropdown ={true}
                                                onChange={this.updateEndDate}/> 
                                    </span>
                                </div>

                                {this.renderLoadingProgress()}
                                {this.renderErrorMessage()}


                                <div className="form-group bmd-form-group">
                                    <button type="submit" onClick={_this.postAnnouncement.bind(_this)} className="btn btn-rose">POST ANNOUNCEMENT</button>  
                                </div>

                                

                              


                            

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <Footer/>

      </div>
    );
  }
}

export default Postnew;
